



































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { OperationItemType } from '../../types/type'
@Component({
  name: 'formModuleDetail',
  components: {
    'my-dialog': () => import('./myDialog.vue'),
    'concise-card-have-title-acquiescent': () => import('./conciseCardHaveTitleAcquiescent.vue')
  }
})
export default class formModuleDetail extends Vue {
  @Prop({ default: '' }) public title: string
  @Prop({ default: '' }) public icon: string
  @Prop({ default: false }) public loading: false
  @Prop({ default: () => [] }) public detailInfoList: any[]
  @Prop({ default: () => [] }) public headerOperationList: OperationItemType[]
  @Prop({ default: '#BBE0E3' }) public bgcOFSetTitle: string

  operationForButton (item: OperationItemType) {
    this.$emit('operationForButton', item)
  }
}
